module.exports = __webpack_public_path__ + "media/Diagnose Clarissa_neu_Stufe02.60ce9a2e.mp4";